import React, { lazy, Suspense, type ComponentType } from 'react';

import type { ModalProps } from './types';

const LazyModal = lazy(() => import('./Modal'));

const ModalWithSuspense: ComponentType<ModalProps> = props => (
  <Suspense fallback={null}>
    <LazyModal {...props} />
  </Suspense>
);

export default ModalWithSuspense;
